
import React from 'react';

export const PencilRulerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M20.71,7.04c0.39-0.39,0.39-1.02,0-1.41l-2.34-2.34c-0.39-0.39-1.02-0.39-1.41,0l-1.83,1.83l3.75,3.75L20.71,7.04z M3,17.25V21h3.75L17.81,9.94l-3.75-3.75L3,17.25z M12,18.5c-1.93,0-3.5-1.57-3.5-3.5c0-0.52,0.12-1,0.31-1.45L4.5,17.81V19.5 h1.69l4.26-4.26C11,15.38,11.48,15.5,12,15.5c1.93,0,3.5-1.57,3.5-3.5c0-0.52-0.12-1-0.31-1.45l2.12-2.12c0.93,0.88,1.5,2.24,1.5,3.75 c0,2.76-2.24,5-5,5S13.69,20.5,12,20.5z" />
  </svg>
);
